/**
 * Profile Page - עמוד פרופיל
 * User profile and settings
 */

import { useAuthStore } from '../store/authStore'
import { roleLabel } from '../config/roles'
import { User, Mail, Phone, Shield } from 'lucide-react'

export default function ProfilePage() {
  const { user } = useAuthStore()

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-heading font-bold text-gray-900 mb-2">
          הפרופיל שלי
        </h1>
        <p className="text-gray-600">נהל את פרטי החשבון שלך</p>
      </div>

      {/* User Info Card */}
      <div className="card mb-6">
        <h2 className="card-header">פרטים אישיים</h2>

        <div className="space-y-4">
          {/* Name */}
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gray-100 rounded-lg">
              <User size={20} className="text-gray-600" aria-hidden="true" />
            </div>
            <div>
              <p className="text-sm text-gray-600">שם מלא</p>
              <p className="font-medium text-gray-900">
                {user?.firstName} {user?.lastName}
              </p>
            </div>
          </div>

          {/* Email */}
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gray-100 rounded-lg">
              <Mail size={20} className="text-gray-600" aria-hidden="true" />
            </div>
            <div>
              <p className="text-sm text-gray-600">אימייל</p>
              <p className="font-medium text-gray-900 ltr text-start">
                {user?.email}
              </p>
              {user?.emailVerified && (
                <span className="badge badge-success text-xs mt-1">
                  מאומת
                </span>
              )}
            </div>
          </div>

          {/* Phone */}
          {user?.phoneNumber && (
            <div className="flex items-center gap-3">
              <div className="p-2 bg-gray-100 rounded-lg">
                <Phone size={20} className="text-gray-600" aria-hidden="true" />
              </div>
              <div>
                <p className="text-sm text-gray-600">טלפון</p>
                <p className="font-medium text-gray-900">
                  {user.phoneNumber}
                </p>
              </div>
            </div>
          )}

          {/* Role */}
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gray-100 rounded-lg">
              <Shield size={20} className="text-gray-600" aria-hidden="true" />
            </div>
            <div>
              <p className="text-sm text-gray-600">תפקיד</p>
              <p className="font-medium text-gray-900">
                {roleLabel(user?.role)}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Security Card */}
      <div className="card">
        <h2 className="card-header">אבטחה</h2>

        <div className="space-y-4">
          {/* MFA Status */}
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-gray-900">אימות דו-שלבי (MFA)</p>
              <p className="text-sm text-gray-600">
                הוסף שכבת אבטחה נוספת לחשבון שלך
              </p>
            </div>
            <span className={`badge ${user?.mfaEnabled ? 'badge-success' : 'badge-warning'}`}>
              {user?.mfaEnabled ? 'מופעל' : 'לא מופעל'}
            </span>
          </div>

          {/* Change Password Button */}
          <button className="btn btn-outline w-full">
            שנה סיסמה
          </button>
        </div>
      </div>
    </div>
  )
}
